import { EventEmitter, Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {CryptoService} from './crypto.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment, isODM} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class GateWayService {

  public upgradeGatewayEmitter: EventEmitter<any> = new EventEmitter<any>();
  constructor(private http: HttpClient,
    private cryptoService: CryptoService) { }

  ReadGatewayList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/list`, params);
  }

  // 前台暫時沒用到
  AddGateway(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/add`, params);
  }

  UpdateGateway(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/update`, params);
  }

  DeleteGateway(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/delete`, params);
  }

  UpgradeGateway(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/upgrade`, params);
  }

  ReadGatewayDeviceList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/device/list`, params);
  }

  ReadMgtMibTrapList(otp): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/mibtrap/list`, {otp: otp});
  }

  ReadMibTrapList(otp): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mibtrap/list`, {otp: otp});
  }

  ReadMgtMibDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/mib/read`, params);
  }

  ReadMibDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mib/read`, params);
  }

  AddMgtMibDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/mib/add`, params);
  }

  UpdateMgtMibDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/mib/update`, params);
  }

  DeleteMgtMibDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/mib/delete`, params);
  }

  ReadMgtTrapDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/trap/read`, params);
  }

  ReadTrapDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/trap/read`, params);
  }

  AddMgtTrapDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/trap/add`, params);
  }

  UpdateMgtTrapDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/trap/update`, params);
  }

  DeleteMgtTrapDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/trap/delete`, params);
  }

  ReadMgtAttribute(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/attribute/list`, params);
  }

  ReadAttribute(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/attribute/list`, params);
  }

  AddMgtAttribute(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/attribute/add`, params);
  }

  UpdateMgtAttribute(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/attribute/update`, params);
  }

  DeleteMgtAttribute(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/mgt/attribute/delete`, params);
  }

  ReadProfileList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/profile/list`, params);
  }

  ReadProfileInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/profile/read`, params);
  }

  AddProfileInfo(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/profile/add`, params);
  }

  UpdateProfileInfo(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/profile/update`, params);
  }

  DeleteProfileInfo(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/profile/delete`, params);
  }
  
  ReadDiscoveryInfoList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/list`, params);
  }
  
  ReadDiscoveryInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/read`, params);
  }

  AddDiscoveryInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/add`, params);
  }

  UpdateDiscoveryInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/update`, params);
  }

  DeleteDiscoveryInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/delete`, params);
  }

  ExecuteDiscoveryList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/execute/list`, params);
  }

  ExecuteDiscovery(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/execute`, params);
  }

  StopExecutingDiscovery(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/execute/stop`, params);
  }

  ConfirmExecutingDiscovery(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/execute/confirm`, params);
  }

  AddDiscoveryResult(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/result/add`, params);
  }

  ReadDiscoveryResultList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/result/list`, params);
  }
  
  ReadCategoryListByUser(otp): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/category/list`, {otp: otp});
  }

  ReadDiscoveryExecutingResultForOneTime(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/result/onetime/read`, params);
  }

  AddDeviceToCloud(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/gateway/discovery/result/device/add`, params);
  }
}
